import axios from "axios";
import api from "../api";
import store from "@/store";
import filter_service from "./filter-service";

function create(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.kit_sizer.save}/${params.kit_size_id}/save`, params)
      .then(async (response) => {
        store.dispatch("address/setAddress", false);
        resolve({
          id: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}) {
  let paginate = params.with_pagination ? { paginate: true } : {};
  let filter_params = filter_service.filter_params(params);
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.budgets}${filter_params}`, params)
      .then((response) => {
        if (params.with_pagination) {
          let data = response.data.data.map((item) => {
            let total_price = item.kit.total_price;
            let power = `${item.kit.power / 1000} kWp`;
            return { ...item, power: power, total_price: total_price };
          });
          resolve({
            budgets: { ...paginate, ...response.data, data: data },
          });
        } else {
          let data = {
            ...response.data,
            data: response.data.data.map((item) => {
              let total_price = item.kit.total_price;
              let power = `${item.kit.power / 1000} kWp`;
              return { ...item, power: power, total_price: total_price };
            }),
          };
          resolve({
            budgets: data,
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function update(body = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.budgets}/${body.id}`, body.params)
      .then(async (response) => {
        store.dispatch("alerts/success", "Orçamento atualizado com sucesso");
        resolve({
          budget: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.budgets}/${id}`)
      .then((response) => {
        resolve({
          budget: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getBudgetById(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .get(`${api.budgets}/${id}`)
      .then((response) => {
        resolve({
          budget: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateDiscount(params) {
  return new Promise(async (resolve, reject) => {
    axios
      .put(`${api.kit_sizer.save}/${params.id}/add_discount`, {
        discount_price: params.discount_price,
      })
      .then((response) => {
        store.dispatch("alerts/success", "Desconto salvo com sucesso");
        resolve({
          budget: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateSalesPromotion(params) {
  return new Promise(async (resolve, reject) => {
    axios
      .put(`${api.kit_sizer.save}/${params.id}/sales_promotion`, {
        sales_promotion: params.sales_promotion,
      })
      .then((response) => {
        store.dispatch("alerts/success", "Promoção de venda salva com sucesso");
        resolve({
          budget: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function exportCsv(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.budgets}/export/csv`, params, { responseType: "blob" })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
  getBudgetById,
  updateDiscount,
  updateSalesPromotion,
  exportCsv
};
